// This file was auto-generated by Fern from our API Definition.
const ShapeTypeValues = {
    Enum: "ENUM",
    Object: "OBJECT",
    Union: "UNION",
    UndiscriminatedUnion: "UNDISCRIMINATED_UNION",
};
export const ShapeType = Object.assign(Object.assign({}, ShapeTypeValues), { _visit: (value, visitor) => {
        switch (value) {
            case ShapeType.Enum:
                return visitor.enum();
            case ShapeType.Object:
                return visitor.object();
            case ShapeType.Union:
                return visitor.union();
            case ShapeType.UndiscriminatedUnion:
                return visitor.undiscriminatedUnion();
            default:
                return visitor._other();
        }
    } });
